import {
  setOrgSearchFilterCustomisation,
  setSearchFilterCustomisationLoad,
} from "@redux/slices/appStateSlice";
import { setFiltersData } from "@redux/slices/searchFilters";
import { ThemeTokenTypes } from "@scenes/splash-screen/types";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

export const useFiltersData = (
  url: string,
  enabled?: boolean,
  type?: string
) => {
  const dispatch = useDispatch();
  const timestamp = Date.now();
  return useQuery({
    queryKey: ["GET_SEARCH_FORM"],
    enabled: enabled,
    queryFn: () =>
      axios.get(url + "?timestamp=" + timestamp).then((data) => {
        if (type === ThemeTokenTypes.ORG) {
          dispatch(setOrgSearchFilterCustomisation(data.data));
        }
        if (type === ThemeTokenTypes.COMPANY) {
          dispatch(setSearchFilterCustomisationLoad(true));
        }
        dispatch(setFiltersData(data.data));
        return data;
      }),
    onError: (err) => {
      console.log("err", err);
    },
  });
};
